import React from "react";
import { Slider, Tooltip } from "antd";
import moment from "moment";
import Utils from "@/utils";
import { useTranslation } from "react-i18next";
import { ReactComponent as FadeInIcon } from "@/assets/icons/fade-in.svg";
import { ReactComponent as FadeOutIcon } from "@/assets/icons/fade-out.svg";
import "@/assets/audioJoiner.less";

const AudioWorkWaveformRender = ({
  audioCutSpeedVolumeObj,
  wavesurferRef,
  currentTime,
  currentTimePercent,
  getCutPercent,
  handleSelected,
  handleSliderTips,
  handleCurrentTimeChange,
  handleRangeChange,
  handleRangeChangeAfter,
}) => {
  const { t } = useTranslation(["audioJoiner"]);
  return (
    <div className="audio-waveform" onClick={handleSelected}>
      <div className="waveform" ref={wavesurferRef}>
        <Tooltip placement="top" title={t("Fade in")} overlayStyle={{ fontSize: 12 }}>
          <span className={`fade-icon left ${audioCutSpeedVolumeObj.fadeIn ? "active" : ""}`}>
            <FadeInIcon />
          </span>
        </Tooltip>
        <Tooltip placement="top" title={t("Fade out")} overlayStyle={{ fontSize: 12 }}>
          <span className={`fade-icon right ${audioCutSpeedVolumeObj.fadeOut ? "active" : ""}`}>
            <FadeOutIcon />
          </span>
        </Tooltip>
        <div className="main-line"></div>
        <div className="frame" id="frame">
          <Slider
            max={100}
            step={0.01}
            value={currentTimePercent}
            tipFormatter={() =>
              moment("00:00:00", "mm:ss:SS")
                .add(Utils.getSeconds(currentTime) / audioCutSpeedVolumeObj.speed, "seconds")
                .format("mm:ss:SS")
                .replace(/:([^:]*)$/, ".$1")
            }
            tooltipVisible
            tooltipPlacement="top"
            getTooltipPopupContainer={() => document.querySelector("#frame")}
            onChange={handleCurrentTimeChange}
          />
        </div>
        <div className={audioCutSpeedVolumeObj.cutOrTrim === "cut" ? "range" : "range trim"} id="range">
          <Slider
            max={100}
            step={0.01}
            range={{ draggableTrack: true }}
            value={[getCutPercent(audioCutSpeedVolumeObj.start), getCutPercent(audioCutSpeedVolumeObj.end)]}
            tipFormatter={value => handleSliderTips(value)}
            tooltipVisible
            tooltipPlacement="bottom"
            getTooltipPopupContainer={() => document.querySelector("#range")}
            onChange={handleRangeChange}
            onAfterChange={handleRangeChangeAfter}
          />
          <div
            className="cover"
            style={{
              left: 0,
              width: getCutPercent(audioCutSpeedVolumeObj.start) + "%",
            }}
          ></div>
          <div
            className="cover"
            style={{
              left: getCutPercent(audioCutSpeedVolumeObj.end) + "%",
              width: 100 - getCutPercent(audioCutSpeedVolumeObj.end) + "%",
            }}
          ></div>
          <div
            className="include"
            style={{
              left: Math.round(getCutPercent(audioCutSpeedVolumeObj.start)) + "%",
              width: Math.round(getCutPercent(audioCutSpeedVolumeObj.end)) - Math.round(getCutPercent(audioCutSpeedVolumeObj.start)) + "%",
            }}
          >
            <span style={{ position: "absolute", bottom: 0, left: "50%", transform: "translateX(-50%)", fontSize: 12 }}>
              {audioCutSpeedVolumeObj.cutOrTrim === "cut"
                ? moment("00:00:00", "mm:ss:SS")
                    .add(
                      (Utils.getSeconds(audioCutSpeedVolumeObj.end) - Utils.getSeconds(audioCutSpeedVolumeObj.start)) / audioCutSpeedVolumeObj.speed,
                      "seconds"
                    )
                    .format("mm:ss:SS")
                    .replace(/:([^:]*)$/, ".$1")
                : moment("00:00:00", "mm:ss:SS")
                    .add(
                      (Utils.getSeconds(audioCutSpeedVolumeObj.duration) -
                        (Utils.getSeconds(audioCutSpeedVolumeObj.end) - Utils.getSeconds(audioCutSpeedVolumeObj.start))) /
                        audioCutSpeedVolumeObj.speed,
                      "seconds"
                    )
                    .format("mm:ss:SS")
                    .replace(/:([^:]*)$/, ".$1")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudioWorkWaveformRender;
